module.exports = __webpack_public_path__ + "img/krzyz-2.1d681fad.jpg";